'use client'

import { Builder } from '@builder.io/react'

import { MediaCard } from './MediaCard'
import { mediaCardDefaults } from './MediaCard.defaults'

Builder.registerComponent(MediaCard, {
  name: 'MediaCard',
  inputs: [
    {
      name: 'mediaType',
      type: 'string',
      enum: ['photo', 'video'],
      defaultValue: 'photo',
      helperText: 'Photo or video media.',
    },
    {
      name: 'desktopImgSrc',
      friendlyName: 'Desktop image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
      defaultValue: mediaCardDefaults.desktopImgSrc,
      showIf: (properties) => properties.get('mediaType') === 'photo',
    },
    {
      name: 'mobileImgSrc',
      friendlyName: 'Mobile image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
      defaultValue: mediaCardDefaults.mobileImgSrc,
      showIf: (properties) => properties.get('mediaType') === 'photo',
    },
    {
      name: 'brightcoveVideoId',
      type: 'string',
      showIf: (properties) => properties.get('mediaType') === 'video',
      defaultValue: mediaCardDefaults.brightcoveVideoId,
    },
    {
      name: 'videoPlayerAspectRatio',
      type: 'string',
      enum: ['16 / 9', '9 / 16'],
      showIf: (properties) => properties.get('mediaType') === 'video',
      defaultValue: mediaCardDefaults.videoPlayerAspectRatio,
    },
    {
      name: 'playAsPopup',
      type: 'boolean',
      showIf: (properties) => properties.get('mediaType') === 'video',
    },
    {
      name: 'desktopHeight',
      helperText: '"auto" if left blank',
      type: 'number',
      showIf: (properties) => properties.get('mediaType') === 'photo',
      defaultValue: mediaCardDefaults.desktopHeight,
    },
    {
      name: 'mobileHeight',
      helperText: '"auto" if left blank',
      type: 'number',
      showIf: (properties) => properties.get('mediaType') === 'photo',
      defaultValue: mediaCardDefaults.mobileHeight,
    },
    {
      name: 'showGradient',
      type: 'boolean',
      defaultValue: mediaCardDefaults.showGradient,
    },
    {
      name: 'redirectUrl',
      type: 'string',
      defaultValue: mediaCardDefaults.redirectUrl,
      showIf: (properties) => properties.get('mediaType') === 'photo',
    },
    {
      name: 'innerPadding',
      type: 'string',
      enum: ['small', 'large'],
      defaultValue: mediaCardDefaults.innerPadding,
    },
    {
      name: 'children',
      type: 'blocks',
      hideFromUI: true,
      helperText: 'This is an editable region.',
      defaultValue: mediaCardDefaults.children,
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/photo.svg',
})
